import Icon, { ICON_CLOSE } from '~/components/icon/index.js';

// ToDo: dataAt should be removed. data-at should always be used.
// dataAt was used to compensate for an issue in styled components but
// that issue is fixed in later versions.
const IconButtonClose = ({ className, onClick, dataAt = '', ...rest }) => (
	<button {...rest} className={className} onClick={onClick} data-at={dataAt}>
		<Icon type={ICON_CLOSE} />
	</button>
);
// TODO: please unify the usage of icons and buttons. The icon-close actually exports a button, and the other icon-**.js (icon-bars.js, icon-checkmark-circle.js and more) exports only svg.
// This component should only export an svg.
const IconClose = () => <Icon type={ICON_CLOSE} />;
export { IconClose };

export default IconButtonClose;
